import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/dashboard.css";
import logo from "../assets/naxora-logo.png";
import poster1 from "../assets/posters/poster1.jpg";
import poster2 from "../assets/posters/poster2.jpg";
import poster3 from "../assets/posters/poster3.jpg";

const API_BASE_URL = "https://growrise.shop";

const HomeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M3 10.5L12 3L21 10.5V20A1 1 0 0 1 20 21H15V14H9V21H4A1 1 0 0 1 3 20V10.5Z"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DepositIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 4V17"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M7 12L12 17L17 12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const WithdrawIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 20V7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M17 12L12 7L7 12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ReferralIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M16.5 21V19.5C16.5 17.8431 15.1569 16.5 13.5 16.5H7.5C5.84315 16.5 4.5 17.8431 4.5 19.5V21"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 13.5C12.5711 13.5 14.25 11.8211 14.25 9.75C14.25 7.67893 12.5711 6 10.5 6C8.42893 6 6.75 7.67893 6.75 9.75C6.75 11.8211 8.42893 13.5 10.5 13.5Z"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 8.25C19.4497 8.25 20.625 9.42525 20.625 10.875C20.625 12.3247 19.4497 13.5 18 13.5"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5 21V19.5C19.4989 18.5085 18.9994 17.5839 18.168 17.04"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SalaryIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect
      x="3"
      y="6"
      width="18"
      height="12"
      rx="2.5"
      stroke="currentColor"
      strokeWidth="1.9"
    />
    <path
      d="M3 10H21"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
    />
    <path
      d="M7 15H10"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
    />
  </svg>
);

const TradeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M4 17L9 12L13 16L20 9"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 9H20V14"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 20H20"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
    />
  </svg>
);

const ProfileIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 12C14.4853 12 16.5 9.98528 16.5 7.5C16.5 5.01472 14.4853 3 12 3C9.51472 3 7.5 5.01472 7.5 7.5C7.5 9.98528 9.51472 12 12 12Z"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.5 21C4.5 17.6863 7.18629 15 10.5 15H13.5C16.8137 15 19.5 17.6863 19.5 21"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SupportIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M8.25 18.75H6.75C5.50736 18.75 4.5 17.7426 4.5 16.5V12.75C4.5 8.60786 7.85786 5.25 12 5.25C16.1421 5.25 19.5 8.60786 19.5 12.75V16.5C19.5 17.7426 18.4926 18.75 17.25 18.75H15.75"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.25 17.25C8.25 16.4216 8.92157 15.75 9.75 15.75H14.25C15.0784 15.75 15.75 16.4216 15.75 17.25V18.75C15.75 19.5784 15.0784 20.25 14.25 20.25H9.75C8.92157 20.25 8.25 19.5784 8.25 18.75V17.25Z"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LogoutIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M15.75 17.25L21 12L15.75 6.75"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 12H9"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 20.25H6.75C5.50736 20.25 4.5 19.2426 4.5 18V6C4.5 4.75736 5.50736 3.75 6.75 3.75H10.5"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Dashboard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const posters = [poster1, poster2, poster3];

  const getToken = () => {
    return (
      localStorage.getItem("token") ||
      localStorage.getItem("naxoraToken") ||
      ""
    );
  };

  useEffect(() => {
    const viewport = document.querySelector('meta[name="viewport"]');

    if (viewport) {
      viewport.setAttribute(
        "content",
        "width=device-width, initial-scale=1, viewport-fit=cover"
      );
    }
  }, []);

  const handleLogout = () => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("naxoraToken");
      localStorage.removeItem("naxoraAuth");
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("naxoraCurrentUser");
      localStorage.removeItem("currentUser");
      localStorage.removeItem("user");
      sessionStorage.clear();
      setUser(null);
      window.location.replace("/login");
    } catch (error) {
      console.error("Logout error:", error);
      window.location.replace("/login");
    }
  };

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const loadProfileOnce = async () => {
      try {
        const token = getToken();

        if (!token) {
          navigate("/login", { replace: true });
          return;
        }

        const response = await fetch(`${API_BASE_URL}/api/auth/profile`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          signal: controller.signal,
        });

        let data = {};
        try {
          data = await response.json();
        } catch {
          data = {};
        }

        if (!response.ok || !data.user) {
          handleLogout();
          return;
        }

        if (!isMounted) return;

        setUser(data.user);
        localStorage.setItem("naxoraAuth", "true");
        localStorage.setItem("isAuthenticated", "true");
        localStorage.setItem("naxoraCurrentUser", JSON.stringify(data.user));
        localStorage.setItem("currentUser", JSON.stringify(data.user));
        localStorage.setItem("user", JSON.stringify(data.user));
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Auth/profile error:", error);
          handleLogout();
        }
      } finally {
        if (isMounted) {
          setLoadingUser(false);
        }
      }
    };

    loadProfileOnce();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [navigate]);

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const handleDeposit = () => {
    closeSidebar();
    navigate("/deposit");
  };

  const handleWithdraw = () => {
    closeSidebar();
    navigate("/withdraw");
  };

  const handleReferral = () => {
    closeSidebar();
    navigate("/team");
  };

  const handleSalary = () => {
    closeSidebar();
    navigate("/salary");
  };

  const handleTrade = () => {
    closeSidebar();
    navigate("/trade");
  };

  const handleProfile = () => {
    closeSidebar();
    navigate("/profile");
  };

  const handleSupport = () => {
    closeSidebar();
    navigate("/support");
  };

  const handleHome = () => {
    closeSidebar();
    navigate("/dashboard");
  };

  const formatPrice = (price) => {
    const numericPrice = Number(price || 0);

    if (numericPrice >= 1000) {
      return `$${numericPrice.toLocaleString(undefined, {
        maximumFractionDigits: 2,
      })}`;
    }

    if (numericPrice >= 1) {
      return `$${numericPrice.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    }

    if (numericPrice >= 0.01) {
      return `$${numericPrice.toFixed(4)}`;
    }

    return `$${numericPrice.toFixed(6)}`;
  };

  if (loadingUser || !user) {
    return (
      <div className="dashboard-page">
        <div className="dashboard-loading-screen">Loading...</div>
      </div>
    );
  }

  return (
    <div className="dashboard-page">
      <button
        type="button"
        className="mobile-menu-toggle"
        onClick={() => setSidebarOpen(true)}
        aria-label="Open menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div
        className={`sidebar-overlay ${sidebarOpen ? "show" : ""}`}
        onClick={closeSidebar}
      ></div>

      <aside className={`dashboard-sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="sidebar-top">
          <img src={logo} alt="GROWRISE" className="sidebar-logo" />

          <button
            type="button"
            className="sidebar-close-btn"
            onClick={closeSidebar}
            aria-label="Close menu"
          >
            ×
          </button>
        </div>

        <div className="sidebar-menu">
          <button
            className="sidebar-item active"
            type="button"
            onClick={handleHome}
            title="Home"
            aria-label="Home"
          >
            <span className="nav-icon">
              <HomeIcon />
            </span>
            <span>Home</span>
          </button>

          <button
            className="sidebar-item"
            type="button"
            onClick={handleDeposit}
            title="Deposit"
            aria-label="Deposit"
          >
            <span className="nav-icon">
              <DepositIcon />
            </span>
            <span>Deposit</span>
          </button>

          <button
            className="sidebar-item"
            type="button"
            onClick={handleWithdraw}
            title="Withdraw"
            aria-label="Withdraw"
          >
            <span className="nav-icon">
              <WithdrawIcon />
            </span>
            <span>Withdraw</span>
          </button>

          <button
            className="sidebar-item"
            type="button"
            onClick={handleReferral}
            title="Referral"
            aria-label="Referral"
          >
            <span className="nav-icon">
              <ReferralIcon />
            </span>
            <span>Referral</span>
          </button>

          <button
            className="sidebar-item"
            type="button"
            onClick={handleSalary}
            title="Salary"
            aria-label="Salary"
          >
            <span className="nav-icon">
              <SalaryIcon />
            </span>
            <span>Salary</span>
          </button>

          <button
            className="sidebar-item"
            type="button"
            onClick={handleTrade}
            title="Trade"
            aria-label="Trade"
          >
            <span className="nav-icon">
              <TradeIcon />
            </span>
            <span>Trade</span>
          </button>

          <button
            className="sidebar-item"
            type="button"
            onClick={handleProfile}
            title="Profile"
            aria-label="Profile"
          >
            <span className="nav-icon">
              <ProfileIcon />
            </span>
            <span>Profile</span>
          </button>

          <button
            className="sidebar-item"
            type="button"
            onClick={handleSupport}
            title="Support"
            aria-label="Support"
          >
            <span className="nav-icon">
              <SupportIcon />
            </span>
            <span>Support</span>
          </button>

          <button
            className="sidebar-logout sidebar-logout-golden"
            onClick={handleLogout}
            type="button"
            title="Logout"
            aria-label="Logout"
          >
            <span className="nav-icon">
              <LogoutIcon />
            </span>
            <span>Logout</span>
          </button>
        </div>
      </aside>

      <main className="dashboard-main">
        <section className="dashboard-topbar">
          <div className="user-balance-card">
            <div className="user-balance-left">
              <span className="balance-label">Total Balance</span>
              <h2>{formatPrice(user.balance)}</h2>
              <p>{user.name || user.username || "User"}</p>
            </div>

            <div className="user-balance-right">
              <div className="user-avatar">
                {(user.name || user.username || "U").charAt(0).toUpperCase()}
              </div>
            </div>
          </div>
        </section>

        <section className="dashboard-action-row">
          <button
            className="action-btn deposit-btn"
            type="button"
            onClick={handleDeposit}
          >
            <div className="action-btn-icon">
              <DepositIcon />
            </div>
            <span>Deposit</span>
          </button>

          <button
            className="action-btn withdraw-btn"
            type="button"
            onClick={handleWithdraw}
          >
            <div className="action-btn-icon">
              <WithdrawIcon />
            </div>
            <span>Withdraw</span>
          </button>

          <button
            className="action-btn referral-btn"
            type="button"
            onClick={handleReferral}
          >
            <div className="action-btn-icon">
              <ReferralIcon />
            </div>
            <span>Referral</span>
          </button>

          <button
            className="action-btn salary-btn"
            type="button"
            onClick={handleSalary}
          >
            <div className="action-btn-icon">
              <SalaryIcon />
            </div>
            <span>Salary</span>
          </button>

          <button
            className="action-btn trade-btn"
            type="button"
            onClick={handleTrade}
          >
            <div className="action-btn-icon">
              <TradeIcon />
            </div>
            <span>Trade</span>
          </button>

          <button
            className="action-btn profile-btn"
            type="button"
            onClick={handleProfile}
          >
            <div className="action-btn-icon">
              <ProfileIcon />
            </div>
            <span>Profile</span>
          </button>

          <button
            className="action-btn support-btn"
            type="button"
            onClick={handleSupport}
          >
            <div className="action-btn-icon">
              <SupportIcon />
            </div>
            <span>Support</span>
          </button>
        </section>

        <section className="dashboard-posters">
          {posters.map((poster, index) => (
            <div className="poster-card" key={index}>
              <img src={poster} alt={`Poster ${index + 1}`} />
            </div>
          ))}
        </section>

        <nav className="dashboard-bottom-nav">
          <button
            className="bottom-nav-btn"
            type="button"
            onClick={handleReferral}
            aria-label="Referral"
          >
            <span className="bottom-nav-icon">
              <ReferralIcon />
            </span>
            <span>Referral</span>
          </button>

          <button
            className="bottom-nav-btn"
            type="button"
            onClick={handleSalary}
            aria-label="Salary"
          >
            <span className="bottom-nav-icon">
              <SalaryIcon />
            </span>
            <span>Salary</span>
          </button>

          <button
            className="bottom-nav-btn"
            type="button"
            onClick={handleTrade}
            aria-label="Trade"
          >
            <span className="bottom-nav-icon">
              <TradeIcon />
            </span>
            <span>Trade</span>
          </button>

          <button
            className="bottom-nav-btn"
            type="button"
            onClick={handleProfile}
            aria-label="Profile"
          >
            <span className="bottom-nav-icon">
              <ProfileIcon />
            </span>
            <span>Profile</span>
          </button>

          <button
            className="bottom-nav-btn active"
            type="button"
            onClick={handleSupport}
            aria-label="Support"
          >
            <span className="bottom-nav-icon">
              <SupportIcon />
            </span>
            <span>Support</span>
          </button>
        </nav>
      </main>
    </div>
  );
};

export default Dashboard;